import { Button, Image } from 'antd';
import { CheckCircleFilled, ZoomInOutlined } from '@ant-design/icons';
import { useLanguage } from 'hooks/Language/useLanguage';
import { IKycDocumentState } from 'utils/kycStatus';

const KycDone: React.FC<{
  documents: IKycDocumentState[];
  previews: Record<string, string | undefined>;
  verified: boolean;
  onClose: () => void;
}> = ({ documents, previews, verified, onClose }) => {
  const { translate } = useLanguage();
  const received = documents.filter((doc) => previews[doc.key]);

  return (
    <div className="kyc-done">
      <span className="kyc-done__icon">
        <CheckCircleFilled />
      </span>
      <h2>
        {verified
          ? translate('You are verified')
          : translate('Documents received')}
      </h2>
      <p>
        {verified
          ? translate(
              'Thank you. Your identity is confirmed and your account is fully active.',
            )
          : translate(
              'Thank you. Our team is reviewing your documents and will activate your account shortly. We will let you know by email.',
            )}
      </p>

      {received.length > 0 && (
        // One gallery: open any thumbnail and page through them all.
        <Image.PreviewGroup preview={{ rootClassName: 'kyc-viewer' }}>
          <ul className="kyc-done__docs">
            {received.map((doc) => (
              <li key={doc.key}>
                <Image
                  src={previews[doc.key]}
                  alt={translate(doc.label)}
                  rootClassName="kyc-done__thumb"
                  preview={{ mask: <ZoomInOutlined /> }}
                />
                <span>{translate(doc.label)}</span>
              </li>
            ))}
          </ul>
        </Image.PreviewGroup>
      )}

      <Button
        type="primary"
        size="large"
        className="kyc-btn-primary kyc-done__cta"
        onClick={onClose}
      >
        {translate('Continue to my account')}
      </Button>
    </div>
  );
};

export default KycDone;
